"use client";

import { useState } from "react";
import { Search } from "lucide-react";
import Reveal from "@/components/motion/Reveal";
import Stagger, { StaggerItem } from "@/components/motion/Stagger";
import ServiceCard from "@/components/Services/ServiceCard";
import type { ServiceData } from "@/data/Static/services";

interface ServicesListClientProps {
  services: ServiceData[];
}

export default function ServicesListClient({ services }: ServicesListClientProps) {
  const [searchTerm, setSearchTerm] = useState("");

  const filteredServices = services.filter(service => 
    service.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    service.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
    service.category?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <section className="py-10 bg-white">
      <div className="container px-4 mx-auto">
        
        {/* Search/Filter Bar */}
        <Reveal>
          <div className="max-w-xl mx-auto mb-8 relative">
            <div className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
              <Search className="w-5 h-5 text-muted-foreground" />
            </div>
            <input 
              type="text" 
              placeholder="Keressen a szolgáltatások között..."
              className="w-full pl-12 pr-6 py-4 rounded-2xl border border-border bg-white shadow-xs focus:ring-4 focus:ring-primary/10 transition-all outline-hidden"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </Reveal>

        {/* Services Grid */}
        {filteredServices.length > 0 ? (
          <Stagger amount={0.01} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredServices.map((service) => (
              <StaggerItem key={service.id}>
                <ServiceCard
                  title={service.title}
                  description={service.description}
                  icon={service.icon}
                  href={service.href}
                  color={service.color}
                  bgColor={service.bgColor}
                  hoverColor={service.hoverColor}
                  hoverBorder={service.hoverBorder}
                />
              </StaggerItem>
            ))}
          </Stagger>
        ) : (
          <Reveal>
            <div className="text-center py-20">
              <p className="text-xl text-muted-foreground">Nincs találat a keresésére.</p>
              <button 
                onClick={() => setSearchTerm("")}
                className="mt-4 text-primary font-bold hover:underline"
              >
                Keresés törlése
              </button>
            </div>
          </Reveal>
        )}

      </div>
    </section>
  );
}
